import React from 'react';
import { renderDate } from '../utility/personTabGridHelper';
import PersonHistoryChangesCell from '../components/add-edit-person/PersonHistoryChangesCell';

export const EVENT_TYPES = {
  CREATED: 'Created',
  MODIFIED: 'Modified',
  DELETED: 'Deleted',
};

export const HISTORY_COLUMNS = [
  {
    field: 'timestamp',
    headerName: 'Date',
    width: 190,
    flex: 1,
    valueFormatter: renderDate,
    sortable: false,
    filterable: false,
  },
  {
    field: 'changedBy',
    headerName: 'Changed By',
    width: 160,
    flex: 1,
    sortable: false,
    filterable: false,
  },
  {
    field: 'event',
    headerName: 'Event',
    width: 120,
    flex: 0.7,
    sortable: false,
    filterable: false,
  },
  {
    field: 'changes',
    headerName: 'Changes',
    width: 360,
    flex: 3,
    sortable: false,
    filterable: false,
    renderCell: ({ value, row }) => <PersonHistoryChangesCell changes={value} event={row.event} />,
  },
];
